var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgKr = function SvgKr(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21786_20461",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21786_20461)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.93888,
    cy: 9.96986,
    rx: 3.267,
    ry: 3.26674,
    fill: "#3A71CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0758 9.75524C10.7807 8.56528 13.5557 9.05473 12.8513 11.4509C14.612 8.40571 10.4257 4.76576 7.59264 7.72082C7.23513 8.02044 7.00781 8.47028 7.00781 8.97321C7.00781 9.8753 7.73916 10.6066 8.64131 10.6066C9.26014 10.6066 9.79859 10.2625 10.0758 9.75524Z",
    fill: "#EA5D5D"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 3.23738,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 4.97266 4.72266)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 3.23738,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 5.66797 5.16797)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 3.23738,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 6.36719 5.61328)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 14.9766 11.3555)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 13.1484 5.91602)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 14.5391 5.02344)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 15.4766 6.45898)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 14.1367 7.35156)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 3.23878,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 13.8633 5.45703)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 3.875 12.1504)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 4.82031 13.5879)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 3.23878,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 3.20312 12.582)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 3.23878,
    transform: "matrix(0.830751 -0.556644 0.556508 0.830843 4.58594 11.707)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 15.6523 11.8008)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 16.3477 12.2461)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 13.9727 12.8398)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 14.6445 13.2852)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.542315,
    height: 1.49349,
    transform: "matrix(0.836436 0.548064 -0.547928 0.836526 15.3398 13.7305)",
    fill: "black"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgKr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/kr.242ad873e96d34287dba77b714f897ce.svg";